import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import * as moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import { getMTEByEmail } from '../../../../services/MTEService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';

import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getFormById } from '../../../../services/FormService';
import ProjectCodesServices from '../../../../services/ProjectCodeService';

const validationSchema = Yup.object().shape({
  travelerName: Yup.object().required('Traveler Name is required'),
  contract: Yup.string().required('Contract Name is required'),
  taskNumber: Yup.string().required('Task Number is required'),
  travelTo: Yup.string().required('Travel To is required'),
  departureDate: Yup.date().required('Departure Date is required'),
  returnDate: Yup.date()
    .required('Return Date is required')
    .min(Yup.ref('departureDate'), 'Return Date must be after Departure Date'),
  purpose: Yup.string().required('Purpose is required'),
  travelers: Yup.string().required('Travelers are required'),
  itinerary: Yup.string().required('Itinerary is required'),
  discussion: Yup.string().required('Discussion is required'),
  conclusions: Yup.string().required('Conclusions are required'),
});

const TravelFormEdit = ({ profile }) => {
  const { id } = useParams(); // Get the ID from URL
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const [taskNumberList, setTaskList] = useState([]);
  const [travelToFormatted, setTravelTo] = useState('');
  const [submitterName, setSubmitterName] = useState('');
  const { showLoader, hideLoader } = useLoader();
  const employeeList = useSelector(employeeSearchList);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [employeeDefault, setEmpListDefault] = useState([]);
  const travelToRef = useRef(null);
  const formikRef = useRef(null);

  const [initialValues, setInitialValues] = useState({
    submitter: submitterName,
    travelerName: '',
    contract: '',
    taskNumber: '',
    travelTo: travelToFormatted,
    departureDate: null,
    returnDate: null,
    purpose: '',
    travelers: '',
    itinerary: '',
    ptoPersonalExpense: false,
    ptoPersonalExpenseDetails: '',
    discussion: '',
    conclusions: '',
    ciDebriefing: false,
    boxFolderId: '0',
    employeeId: 'NA',
    boxFolderName: 'Tripreport-Forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
    ProjectCodesServices.getProjectCode('')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setTaskList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });
  }, [dispatch]);

  useEffect(() => {
    let autocomplete;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&language=en&key=AIzaSyATKjIlSQfOGE4nuZOmD5D0uCn06-taWlU&callback=initAutocomplete`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    window.initAutocomplete = () => {
      if (travelToRef.current) {
        autocomplete = new window.google.maps.places.Autocomplete(travelToRef.current, {
          types: ['(cities)'],
        });

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          const fullAddress = place.formatted_address || '';
          setTravelTo(fullAddress);
          if (travelToRef.current) {
            travelToRef.current.value = fullAddress;
          }
          if (formikRef.current) {
            formikRef.current.setFieldValue('travelTo', fullAddress);
          }
        });
      }
    };

    return () => {
      if (autocomplete) {
        window.google.maps.event.clearInstanceListeners(autocomplete);
      }
      document.body.removeChild(script);
    };
  }, []);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  useEffect(() => {
    if (id) {
      showLoader();
      getFormById(id)
        .then((formData) => {
          if (formData) {
            getUsersSearch(formData.dynamicFields.travelerName.split(' ')[0])
              .then((response) => {
                const options = response.data.map((employee) => ({
                  value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  email: employee.email,
                  employeeNumber: employee.employeeNumber,
                }));
                setEmpListDefault(options);
              })
              .catch((error) => {
                console.error('Error fetching employee data 2', error);
              });
            // Updating initial values based on fetched form data

            setInitialValues({
              submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
              travelerName: {
                value: formData.dynamicFields.travelerName,
                label: formData.dynamicFields.travelerName,
                email: formData.dynamicFields.email,
                employeeNumber: formData.dynamicFields.employeeId,
              },
              contract: formData.dynamicFields.contract,
              taskNumber: formData.dynamicFields.taskNumber,
              travelTo: formData.dynamicFields.travelTo,
              departureDate: moment(formData.dynamicFields.departureDate).toDate(),
              returnDate: moment(formData.dynamicFields.returnDate).toDate(),
              purpose: formData.dynamicFields.purpose,
              travelers: formData.dynamicFields.travelers,
              itinerary: formData.dynamicFields.itinerary,
              ptoPersonalExpense: formData.dynamicFields.ptoPersonalExpense,
              ptoPersonalExpenseDetails: formData.dynamicFields.ptoPersonalExpenseDetails,
              discussion: formData.dynamicFields.discussion,
              conclusions: formData.dynamicFields.conclusions,
              ciDebriefing: formData.dynamicFields.ciDebriefing,
              employeeId: formData.dynamicFields.employeeId,
              boxFolderId: formData.dynamicFields.boxFolderId,
              boxFolderName: 'Tripreport-Forms',
              timestamp: moment().unix(),
            });
            ProjectCodesServices.getProjectCode(formData.dynamicFields.employeeId || '')
              .then((response) => {
                // Ensure response and data exist and are valid
                if (!response || !Array.isArray(response.data) || response.data.length === 0) {
                  console.log('Invalid or empty project code data');
                  return; // Early return if no valid data
                }

                // Flatten and map project codes, with additional checks
                const codeList = response.data.flatMap(({ projectCodes }) =>
                  Array.isArray(projectCodes) && projectCodes.length > 0
                    ? projectCodes.map((code) => ({
                        value: code,
                        label: code,
                      }))
                    : []
                );

                // Update state with the final list of project codes, only if codeList is not empty
                if (codeList.length > 0) {
                  setTaskList(codeList);
                } else {
                  console.log('No valid project codes found.');
                }
              })
              .catch((error) => {
                console.error('Error fetching project codes:', error);
              });
          }
        })
        .finally(() => {
          hideLoader();
        });
    }
  }, [id]);

  const handleTaskNumberChange = (selectedOption, setFieldValue) => {
    setFieldValue('taskNumber', selectedOption.value);
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`travelerName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`contract`, '');
      setFieldValue(`employeeId`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    const getManager = await getMTEByEmail(selectedOption.email);
    if (
      typeof getManager != 'undefined' &&
      typeof getManager.contract != 'undefined' &&
      getManager.contract != '' &&
      getManager.contract.toLowerCase() != profile.contract.toLowerCase() &&
      profile.role.toLowerCase() !== 'admin'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'You are not accosiated with selected employee contract, please select correct employee and contract',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`contract`, '');
      setFieldValue(`employeeId`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }

    ProjectCodesServices.getProjectCode(selectedOption.employeeNumber || '')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setTaskList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });

    setFieldValue(`contract`, getManager.contract || '');
    setFieldValue(`employeeId`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`boxFolderId`, folderIdRes.folderId || '0');
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'tripreport-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    console.log('tttt --- ', data);
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        travelerName: data.travelerName.value,
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Edit Trip Report Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1718828987131"
          >
            Instruction to Submit the Trip report
          </Link>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          innerRef={formikRef}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="travelerName">Traveler Name</label>
                    <AsyncSelect
                      name="travelerName"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Traveler"
                      isSearchable
                      onChange={(selectedOption) =>
                        handleEmployeeChange(selectedOption, setFieldValue)
                      }
                      value={values.travelerName}
                    />
                    <ErrorMessage name="travelerName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="contract">Contract Name</label>
                    <Field
                      type="text"
                      name="contract"
                      className="form-control"
                      placeholder="Contract"
                      value={values.contract}
                      readOnly
                    />
                    <ErrorMessage name="contract" component="div" className="text-danger" />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label htmlFor="taskNumber">Task Number</label>
                    <Select
                      name={`taskNumber`}
                      options={taskNumberList}
                      onChange={(option) => handleTaskNumberChange(option, setFieldValue)}
                      value={
                        Array.isArray(values.taskNumber)
                          ? taskNumberList.map((opt) => {
                              if (values.taskNumber.includes(opt.value)) {
                                return opt;
                              }
                            })
                          : typeof values.taskNumber === 'string'
                          ? taskNumberList.map((opt) => {
                              if (values.taskNumber == opt.value) {
                                return opt;
                              }
                            })
                          : values.taskNumber
                      } // Finding the correct option based on account_code
                    />
                    <ErrorMessage name="taskNumber" component="div" className="text-danger" />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label htmlFor="travelTo">Travel To</label>
                    <Field name="travelTo">
                      {({ field }) => (
                        <input
                          {...field}
                          ref={travelToRef}
                          className="form-control"
                          value={travelToFormatted || values.travelTo}
                          onChange={(e) => {
                            const value = e.target.value;
                            setTravelTo(value);
                            setFieldValue('travelTo', value);
                          }}
                        />
                      )}
                    </Field>

                    <ErrorMessage name="travelTo" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="departureDate">Departure Date</label>
                    <DatePicker
                      selected={values.departureDate}
                      onChange={(date) => setFieldValue('departureDate', date)}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                    />
                    <ErrorMessage name="departureDate" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="returnDate">Return Date</label>
                    <DatePicker
                      selected={values.returnDate}
                      onChange={(date) => setFieldValue('returnDate', date)}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                    />
                    <ErrorMessage name="returnDate" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="purpose">Purpose</label>
                    <Field
                      as="textarea"
                      name="purpose"
                      className="form-control"
                      placeholder="Why did you travel"
                    />
                    <ErrorMessage name="purpose" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="travelers">Traveler(s)</label>
                    <Field
                      as="textarea"
                      name="travelers"
                      className="form-control"
                      placeholder="John Doe, Jane Doe"
                    />
                    <ErrorMessage name="travelers" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="itinerary">Itinerary</label>
                    <Field
                      as="textarea"
                      name="itinerary"
                      className="form-control"
                      placeholder="Day1, Day2, Day3"
                    />
                    <ErrorMessage name="itinerary" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>
                      <Field type="checkbox" name="ptoPersonalExpense" /> PTO/Personal Expense
                      Incurred
                    </label>
                  </div>
                  {values.ptoPersonalExpense && (
                    <Field
                      as="textarea"
                      name="ptoPersonalExpenseDetails"
                      className="form-control"
                      placeholder="Details of expenses..."
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="discussion">Discussion</label>
                    <Field
                      as="textarea"
                      name="discussion"
                      className="form-control"
                      placeholder="Trip Objective, analysis, etc."
                    />
                    <ErrorMessage name="discussion" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="conclusions">Conclusions</label>
                    <Field
                      as="textarea"
                      name="conclusions"
                      className="form-control"
                      placeholder="Summarize findings from Trip"
                    />
                    <ErrorMessage name="conclusions" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>
                      <Field type="checkbox" name="ciDebriefing" /> CI Debriefing
                    </label>
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit">
                  Re-submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
});

export default connect(mapStateToProps)(TravelFormEdit);
